/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Title_HintInputs */

const es_cap_title_hint = /** @type {(inputs: Cap_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debe coincidir con el título que podamos verificar.`)
};

const gl_cap_title_hint = /** @type {(inputs: Cap_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debe coincidir co título que poidamos verificar.`)
};

const en_cap_title_hint = /** @type {(inputs: Cap_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must match the credential we can verify.`)
};

/**
* | output |
* | --- |
* | "Must match the credential we can verify." |
*
* @param {Cap_Title_HintInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_title_hint = /** @type {((inputs?: Cap_Title_HintInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Title_HintInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_title_hint(inputs)
	if (locale === "en") return en_cap_title_hint(inputs)
	return es_cap_title_hint(inputs)
});